import { SDLUtil, RequestUtil, StringUtil } from '@/utils';

const setAccountData = ({ commit }, data) => {
  commit('SET_ACCOUNT_DATA', data);
};

const setAccountInfo = ({ commit }, data) => {
  commit('SET_ACCOUNT_INFO', data);
};

const setRootAccountData = ({ commit }, data) => {
  commit('SET_ROOT_ACCOUNT_DATA', data);
};

const setRootAccountInfo = ({ commit }, data) => {
  commit('SET_ROOT_ACCOUNT_INFO', data);
};

export default {
  async SEARCH_ACCOUNT_DATA(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accountManagement/accountRequest/selectAccountList?${StringUtil.queryStringfy(param)}`);
    setAccountData(store, data.data);
  },
  async SEARCH_ACCOUNT_INFO(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accountManagement/accountRequest/selectAccountInfo?${StringUtil.queryStringfy(param)}`);
    setAccountInfo(store, data.data);
  },
  async SAVE_ACCOUNT_INFO(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/accountManagement/accountRequest/saveAccountInfo`, param);
  },
  async SEARCH_ROOT_ACCOUNT_DATA(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accountManagement/accountRequest/selectRootAccountList?${StringUtil.queryStringfy(param)}`);
    setRootAccountData(store, data.data);
  },
  async SEARCH_ROOT_ACCOUNT_INFO(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accountManagement/accountRequest/selectRootAccountInfo?${StringUtil.queryStringfy(param)}`);
    setRootAccountInfo(store, data.data);
  },
  async SAVE_ROOT_ACCOUNT_INFO(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/accountManagement/accountRequest/saveRootAccountInfo`, param);
  },
  async SEARCH_DIVION_ROOT_ACCOUNT_DATA(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accountManagement/accountRequest/selectDivionRootAccountList?${StringUtil.queryStringfy(param)}`);
    setRootAccountData(store, data.data);
  },
  async SEARCH_DIVION_ROOT_ACCOUNT_INFO(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accountManagement/accountRequest/selectDivionRootAccountInfo?${StringUtil.queryStringfy(param)}`);
    setRootAccountInfo(store, data.data);
  },
  async SAVE_DIVION_ROOT_ACCOUNT_INFO(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/accountManagement/accountRequest/saveDivionRootAccountInfo`, param);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accountManagement/accountRequest/accountRequestAction.js